<script lang="ts">
      import { goto } from '$app/navigation'
      import { untrack } from 'svelte'
      import { getLocaleContext } from './ts/Locale.svelte'

      const locale = getLocaleContext()

      async function navigateTo(ev: Event) {
            ev.preventDefault()
            goto(_url, {
                  invalidateAll: true,
            })
      }

      function switchUrl() {
            let prefix = ''
            if (locale.defaultLocale != _locale) prefix = '/' + _locale

            if (!locale.currentPage) {
                  return prefix + '/'
            }
            const _page = locale.currentPage.find((page) => page.locale == _locale)
            let slug = _page ? _page.slug : ''

            if( slug == "home" ) slug = ""

            return prefix + '/' + slug
      }

      $effect( () => {
        locale.locale
        locale.currentPage
        untrack(() => {
          _url = switchUrl()
        })
      })


      let _locale = $derived.by(() => {
            return locale.locales.find((l) => l !== locale.locale)
      })

      let _url = $state("#")

      let { class: className = '', children = undefined } = $props()
</script>

<a href={_url} onclick={navigateTo} class="relative uppercase {className == '' ? 'flex items-center justify-center text-right' : className}">
      <!--<div class="absolute w-[3rem] h-[2.5rem] mb-1 border-[1px] border-black rounded-full"></div>-->
      {_locale}
      {@render children?.()}
</a>

<style lang="postcss">
</style>
